module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_family@3x-3df459aedcc48e18109771fc01d2e3c2.webp";